'use strict';
import 'core-js/actual';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// GALLERY
const imageContainerEl = document.querySelector('.gallery__image-container');
const prevEl = document.querySelector('.gallery__btn--prev');
const nextEl = document.querySelector('.gallery__btn--next');

const imgContainerElArr = document.querySelectorAll(
  '.gallery__image-container',
);
const prevElArr = document.querySelectorAll('.gallery__btn--prev');
const nextElArr = document.querySelectorAll('.gallery__btn--next');

let x = [];
let timer = [];

// prevEl.addEventListener('click', () => {
//   x += 45;
//   clearTimeout(timer);
//   updateGallery();
// });
// nextEl.addEventListener('click', () => {
//   x -= 45;
//   clearTimeout(timer);
//   updateGallery();
// });

function updateGallery(i) {
  // imageContainerEl.style.transform = `perspective(1000px) rotateY(${x}deg)`;
  // timer = setTimeout(() => {
  //   x -= 45;
  //   updateGallery();
  // }, 3000);

  imgContainerElArr[i].style.transform =
    `perspective(1000px) rotateY(${x[i]}deg)`;
  timer[i] = setTimeout(() => {
    x[i] = x[i] - 45;
    updateGallery(i);
  }, 3000);
}

// updateGallery();

// console.log(nextElArr);
// console.log(prevElArr);

const updateGalleryArr = () => {
  imgContainerElArr.forEach((el, i) => {
    x[i] = 0;
  });
  imgContainerElArr.forEach((el, i) => {
    el.style.transform = `perspective(1000px) rotateY(${x[i]}deg)`;
    // console.log(i);
    timer[i] = setTimeout(() => {
      x[i] -= 45;
      updateGallery(i);
    }, 3000);
  });

  // console.log(imgContainerElArr);

  // console.log(x);
};

prevElArr.forEach((el, i) => {
  // console.log(el);
  el.addEventListener('click', () => {
    x[i] = x[i] + 45;
    clearTimeout(timer[i]);
    updateGallery(i);
  });
});
nextElArr.forEach((el, i) => {
  el.addEventListener('click', () => {
    x[i] = x[i] - 45;
    clearTimeout(timer[i]);
    updateGallery(i);
  });
});

updateGalleryArr();

// CONTACT POPUP
const popupCloseEl = document.querySelector('.contact__popup--close');
const popupIconEl = document.querySelector('.contact__popup--open');
const contactPopupEl = document.querySelector('.contact__popup');
const popupContentEl = document.querySelector('.contact__popup--content');

popupIconEl.addEventListener('click', () => {
  console.log(contactPopupEl);
  contactPopupEl.classList.add('open');
});
popupCloseEl.addEventListener('click', () => {
  console.log(contactPopupEl);
  contactPopupEl.classList.remove('open');
});
